import React from 'react'

import Svg, { Path } from 'react-native-svg'

const CardGroup = ({ size, color, ...props }) => {
  return (
    <Svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      {...props}
    >
      <Path
        d="M21.36 8.54688H2.64C1.18667 8.54688 0 9.73354 0 11.1869V21.3469C0 22.8002 1.18667 23.9869 2.64 23.9869H21.36C22.8133 23.9869 24 22.8002 24 21.3469V11.1869C24 9.73354 22.8133 8.54688 21.36 8.54688ZM2.93333 13.0802C2.93333 12.4802 3.42667 12.0002 4.01333 12.0002H10.92C11.52 12.0002 12 12.4935 12 13.0802C12 13.6669 11.5067 14.1602 10.92 14.1602H4.01333C3.41333 14.1602 2.93333 13.6669 2.93333 13.0802ZM8.64 19.7202C8.64 20.1202 8.30667 20.4535 7.90667 20.4535H4.02667C3.62667 20.4535 3.29333 20.1202 3.29333 19.7202V19.4002C3.29333 19.0002 3.62667 18.6669 4.02667 18.6669H7.90667C8.30667 18.6669 8.64 19.0002 8.64 19.4002V19.7202ZM15.1733 19.7202C15.1733 20.1202 14.84 20.4535 14.44 20.4535H10.56C10.16 20.4535 9.82667 20.1202 9.82667 19.7202V19.4002C9.82667 19.0002 10.16 18.6669 10.56 18.6669H14.44C14.84 18.6669 15.1733 19.0002 15.1733 19.4002V19.7202ZM21.7067 19.7202C21.7067 20.1202 21.3733 20.4535 20.9733 20.4535H17.0933C16.6933 20.4535 16.36 20.1202 16.36 19.7202V19.4002C16.36 19.0002 16.6933 18.6669 17.0933 18.6669H20.9733C21.3733 18.6669 21.7067 19.0002 21.7067 19.4002V19.7202Z"
        fill={color}
      />
      <Path
        d="M7.13385 5.20022C7.33385 4.72022 7.89385 4.48022 8.37385 4.68022L12.3072 6.30688C12.7872 6.50688 13.0272 7.06688 12.8272 7.54688C12.7472 7.74688 12.5872 7.89355 12.4139 8.00022H22.1072C21.9472 7.48022 21.5739 7.02688 21.0405 6.78688L8.22719 0.986883C7.22719 0.53355 6.05385 0.986883 5.60052 1.97355L2.86719 8.00022H11.4272L7.64052 6.44022C7.16052 6.24022 6.92052 5.68022 7.12052 5.20022H7.13385Z"
        fill={color}
      />
    </Svg>
  )
}

export default CardGroup
